import {FLAG_PREFIX} from "../../constants/tokens";

export const checkIfFlag = (tokenId) => {
  if (!tokenId) {
    return false;
  }
  return tokenId.includes(FLAG_PREFIX)
}